/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Week_Number_HeaderInputs */

const fr_calendar_week_number_header = /** @type {(inputs: Calendar_Week_Number_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de semaine`)
};

const en_calendar_week_number_header = /** @type {(inputs: Calendar_Week_Number_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week number`)
};

/**
* | output |
* | --- |
* | "Week number" |
*
* @param {Calendar_Week_Number_HeaderInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_week_number_header = /** @type {((inputs?: Calendar_Week_Number_HeaderInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Week_Number_HeaderInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_week_number_header(inputs)
	return fr_calendar_week_number_header(inputs)
});